import React, {
	useEffect,
	useState,
	useContext,
	useRef,
	useCallback,
} from "react";
import { offerwallapi } from "../../config/axiosconfig";
import { Link, useParams } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
// faHeart,
// faEnvelope,
// faCopy,
// } from "@fortawesome/free-regular-svg-icons";
import "./offerdetails.css";
// import PageHeader from "../../components/masterlayout/PageHeader";
// import Loader from "../../components/skeleton/Loader";

import { ClientContext } from "../../context/client/ClientContext";
import { useNavigate } from "react-router-dom";
// import ISaveMoreModal from "../../components/masterlayout/ISaveMoreModal";
// import { FavouritesContext } from "../../context/favourites/FavouritesContext";
// import { addFavourites, deleteFavourites } from "../../utils/favourites";
// import { setFavourites } from "../../utils/offers";
import { OffersContext } from "../../context/offers/OffersContext";
import { ParamsContext } from "../../context/params/ParamsContext";
import OfferList from "../../components/offers/RecommendedOffers";
import { TenantContext } from "../../context/tenant/TenantContext";
import RecommendedOffers from "../../components/offers/RecommendedOffers";
import { FormatDateYYYYMDD, FormatDateShortMonth } from "../../utils/dates";
import Skeleton from "../../components/skeletons/Skeleton";
import { LanguageContext } from "../../context/language/LanguageContext";
import {
	FacebookIcon,
	FacebookShareButton,
	LinkedinIcon,
	LinkedinShareButton,
	TwitterShareButton,
	XIcon,
} from "react-share";
import {
	GoogleMap,
	InfoWindow,
	Marker,
	useJsApiLoader,
} from "@react-google-maps/api";
import DOMPurify from "dompurify";
import { Button, Modal, OverlayTrigger, Popover, Spinner } from "react-bootstrap";
import { analytics } from "../../utils/analytics";
import { CardContext } from "../../context/card/CardContext";
import { useCountdown } from "../../hooks/useCountdown";
import { useOfferActivation } from "../../hooks/useOfferActivation";
import { useOfferState } from "../../hooks/useOfferState";
import OfferActivation from "../../components/offers/OfferActivation";
import SingleOfferActivation from "../../components/offers/SingleOfferActivation";
import GMap from "./GMap";

// import OfferList from "../../components/skeleton/OfferList";
// import FiveOfferSection from "../../components/sectionlayouts/FiveOfferSection";
// import "../../css/style.css";

export default function OfferDetail() {
	const { client } = useContext(ClientContext);
	const { offers, offersdispatch } = useContext(OffersContext);
	const { awsparams } = useContext(ParamsContext);
	const { tenant } = useContext(TenantContext);
	const { language } = useContext(LanguageContext);
	const { card } = useContext(CardContext);

	// const { favourites, favouritesdispatch } = useContext(FavouritesContext);
	const navigate = useNavigate();
	let trackingUrl = "";

	const [offer, setOffer] = useState();
	const [showMessageModal, setShowMessageModal] = useState(false);

	const params = useParams();
	const offerid = params.offerid;
	const tenanturl = params.tenanturlpathname;
	const [isGiveaway, setIsGiveaway] = useState(false);
	const [isFav, setIsFav] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const handleClose = () => setIsOpen(false);
	const handleShow = () => setIsOpen(true);
	const [copied, setCopied] = useState(false);
	const [isCouponCopied, setIsCouponCopied] = useState(false);

	const [isHow, setIsHow] = useState();
	const [locations, setLocations] = useState();
	const [locationsFiltered, setLocationsFiltered] = useState();


	// const { languageid, languagecode } = localStorage.getItem("l")
	// 	? JSON.parse(localStorage.getItem("l"))
	// 	: { languageid: 529, languagecode: "ja", languagename: "Japanese" };


	// const { isLoaded } = useJsApiLoader({
	// 	id: "google-map-script",
	// 	googleMapsApiKey: process.env.REACT_APP_GOOGLEMAPAPIKEY,
	// 	language: languagecode,
	// });




	// const [map, setMap] = useState(null);
	// const [mapCenter, setMapCenter] = useState(null);
	// const [isLocSelected, setisLocSelected] = useState();
	// const [locInfo, setLocInfo] = useState(null);

	const {
		remainingTime,
		isUnderGap,
		activated,
		startCountdown,
		setActivated,
		cleanup,
		setIsUnderGap,
	} = useCountdown({ tenant });

	const {
		isAttrLoaded,
		isSingleActivation,
		singleOfferActivated,
		isUnlimitedReactivation,
		unlimitedOfferActivated,
		isFinalActivation,
		setSingleOfferActivated,
		setUnlimitedOfferActivated,
	} = useOfferState({
		offer,
		client,
		tenant,
		startCountdown,
		setActivated,
		setIsUnderGap,
	});

	const { loader, message, activateOffer, setLoader } = useOfferActivation({
		offer,
		client,
		tenant,
		card,
		language,
		setActivated,
		isUnlimitedReactivation,
		setUnlimitedOfferActivated,
		isSingleActivation,
		setSingleOfferActivated,
		startCountdown,
	});
	// const getPathSegment = () => {
	// const url = new URL(window.location.href);
	// const pathname = url.pathname;
	// const segments = pathname.split("/");
	// const id = segments[segments.length - 1]; // Gets the last segment
	// return id;
	// };

	// const allowedIds = [
	// "2539",
	// "2540",
	// "2542",
	// "2543",
	// "2544",
	// "2545",
	// "2546",
	// "2547",
	// "2548",
	// "7602",
	// ];
	// const id = getPathSegment();

	// if (!client) {
	// if (!allowedIds.includes(id)) {
	// // navigate("/login");
	// }
	// } else {
	// trackingUrl = offer?.trackingUrl + "&externalUserId=" + client.euid;
	// }

	const selectStore = (e) => {
		e.preventDefault();

		let element;
		if (
			e.target.classList.lenght > 0 &&
			e.target.classList.indexOf("locationdiv") > -1
		) {
			element = e.target;
		} else {
			element = e.target.closest(".locationdiv");
		}

		let sibling = element.parentNode.firstChild;

		// collecting siblings
		while (sibling) {
			if (sibling.nodeType === 1 && sibling !== e) {
				sibling.classList.remove("ow-primary-blue");
			}
			sibling = sibling.nextSibling;
		}
		element.classList.add("ow-primary-blue");
		// setMapCenter(JSON.parse(element.getAttribute("location")));
		// setLocInfo(JSON.parse(element.getAttribute("nameandaddress")));
	};
	const getOfferbyID = async () => {
		try {
			setLoader(true);

			let cardnumber = null;
			card?.map((crd) => {
				if (crd.isdefault === 1) cardnumber = crd.cardnumber;
			});

			const res = await offerwallapi.get("/api/offers/offerbyid", {
				params: {
					tenantid: tenant.tenantid,
					offerid,
					languagecode: language.languagecode,
					cardnumber,
				},
			});

			const offer = res.data.offers[0];
			setOffer(offer);

			// if (res.data.tags.length > 0) setIsHow(res.data.tags[0].trim() === "How");

			const offerlocs = await offerwallapi.get(
				"/api/offers/getofferlocations",
				{
					params: {
						tenantid: tenant.tenantid,
						offerid,
					},
				}
			);

			const locationsdata = offerlocs?.data;
			for (let i = 0; i < locationsdata.length; i++) {
				if (locationsdata[i].name) {
					locationsdata[i].longitude = parseFloat(locationsdata[i].longitude);
					locationsdata[i].latitude = parseFloat(locationsdata[i].latitude);
				} else {
					locationsdata.splice(i, 1);
				}
			}

			setLocations(locationsdata);
			setLocationsFiltered(locationsdata)
			// if (locationsdata.length > 0) {
			// 	setMapCenter({
			// 		lat: locationsdata[0].latitude,
			// 		lng: locationsdata[0].longitude,
			// 	});
			// 	setLocInfo({
			// 		name: locationsdata[0].name,
			// 		address: locationsdata[0].address,
			// 	});
			// }

			const analyticsdata = {
				ut: client ? "Member" : "Guest",
				ui: client ? client.externaluserid : "",
				oi: offer?.id,
				ct: offer?.targetMerchants[0]?.category.name,
				rt: offer.rewardType,
				ra: offer.rewardValue,
				dt: "web",
				ti: tenant?.tenantid,
				tn: tenant?.tenantname,
			};

			analytics(analyticsdata, "offer-view");

			// const bounds = new window.google.maps.LatLngBounds({ lat: offerlocs.data[0].latitude, lng: offerlocs.data[0].longitude });
			// map.fitBounds(bounds);

			// offerlocs.data?.map((loc, index) => {

			// new window.google.maps.Marker({
			// position: { lat: loc.latitude, lng: loc.longitude },
			// map,
			// })
			// });
			// setMap(map);

			setLoader(false);
		} catch (error) {
			console.log(error);
			setLoader(false);
		}
	};

	// const getStoreLocations = async () => {
	// alert(isLoaded)
	// if (isLoaded) {
	// const offerlocs = await offerwallapi.get("/api/offers/getofferlocations", {
	// params: {
	// tenantid: tenant.tenantid,
	// offerid,
	// },
	// });

	// setLocations(offerlocs.data);

	// const bounds = new window.google.maps.LatLngBounds({ lat: offerlocs.data[0].latitude, lng: offerlocs.data[0].longitude });
	// map.fitBounds(bounds);

	// offerlocs.data?.map((loc, index) => {

	// new window.google.maps.Marker({
	// position: { lat: loc[index].latitude, lng: loc[index].longitude },
	// map,
	// })
	// });
	// setMap(map);
	// }
	// }
	// useEffect(() => {
	// if (isLoaded) {
	// getStoreLocations();
	// }
	// }, [isLoaded]);

	useEffect(() => {
		if (tenant) {
			setOffer(null);
			if (language) getOfferbyID();
			// getStoreLocations();
		}
	}, [params, tenant, language]);

	useEffect(() => {
		if (!params.searchtext) {
			document.getElementById("txtGlobalSearch").value = "";
		}
		// if (tenant) {
		// setOffer(null);
		// getOfferbyID();
		// }
	}, []);

	// useEffect(() => {
	// if (favourites) {
	// const favid = parseInt(params.favid ? params.favid : params.id);
	// setIsFav(favourites.indexOf(favid) > -1);
	// }
	// }, [favourites]);

	// useEffect(() => {
	// const detailBread = [{ label: "Home", path: "/" }];
	// detailBread.push({
	// label: "Offers",
	// path: `/visa-japan`,
	// });

	// setBreadcrumbs(detailBread);
	// }, []);

	// const updateFavourites = async (e, offerid) => {
	// e.preventDefault();
	// try {
	// const favs = [...favourites];
	// favouritesdispatch({ type: "FAVOURITES_START" });

	// if (favs.indexOf(offerid) === -1) {
	// const res = await addFavourites(client.euid, offerid);
	// favs.push(offerid);
	// } else {
	// const res = await deleteFavourites(client.euid, offerid);
	// favs.splice(favs.indexOf(offerid), 1);
	// }
	// favouritesdispatch({ type: "FAVOURITES_SUCCESS", payload: favs });
	// const offersOrganized = setFavourites(offers.all, favs);
	// offersdispatch({ type: "OFFERS_SUCCESS", payload: offersOrganized });
	// } catch (error) {

	// favouritesdispatch({ type: "FAVOURITES_FAIL", payload: error });
	// }
	// };

	// const divMap = useRef();

	// useEffect(() => {
	// new window.google.maps.Map(divMap.current, {
	// center: { lat: 37.7749, lng: -122.4194 },
	// zoom: 8,
	// });
	// });

	// const locations2 = [
	// { storeName: "Store 1", storeAddress: "Store 1, Address 1", position: { lat: 6.9009428, lng: 79.8982144 } },
	// { storeName: "Store 2", storeAddress: "Store 2, Address 2", position: { lat: 6.9029428, lng: 79.8982144 } },
	// // { lat: 6.9009428, lng: 79.8982144 }

	// ];

	// const center = { lat: 6.9009428, lng: 79.8982144 };

	// const onLoad = React.useCallback(
	// 	function callback(map) {
	// 		// alert(locations)
	// 		// This is just an example of getting and using the map instance!!! don't just blindly copy!
	// 		// if (locations?.length > 0) {
	// 		// const bounds = new window.google.maps.LatLngBounds({ lat: locations[0].latitude, lng: locations[0].longitude });
	// 		// map.fitBounds(bounds);
	// 		// locations?.map((loc, index) => {
	// 		// new window.google.maps.Marker({
	// 		// position: { lat: loc[index].latitude, lng: loc[index].longitude },
	// 		// map,
	// 		// })
	// 		// });
	// 		// setMap(map);
	// 		// }
	// 	},
	// 	[locations]
	// );

	// const onUnmount = React.useCallback(function callback(map) {
	// 	setMap(null);
	// }, []);

	// useEffect(() => {
	// 	getOfferAttributes();
	// }, []);

	const closeMessageModal = () => {
		setShowMessageModal(false);
	};

	//check offer start date
	const checkStartDate = (offer) => {
		const validFrom = new Date(offer.validFrom);
		const published = new Date(offer.published);
		// Convert the published date to the given timeZone
		const publishedLocal = new Date(
			published.toLocaleString("en-US", { timeZone: offer.timeZone })
		);
		return publishedLocal < validFrom ? validFrom : publishedLocal;
	};

	const filterLocations = (e) => {
		// console.log("val : ", e.target.value);

		const filtered = locations.filter((storeLoc) => {
			return storeLoc.name.toLowerCase().includes(e.target.value.toLowerCase())
		})

		setLocationsFiltered(filtered)

	}

	return (
		<>
			{/* {
JSON.stringify(locations)
} */}
			{/* <PageHeader title={offer?.title} breadcrumbs={breadcrumbs} /> */}
			<div className="container pt-30 ">
				<nav aria-label="breadcrumb">
					<ol className="breadcrumb">
						<li className="breadcrumb-item">
							<i className="bi bi-house me-2"></i>
							<Link
								to={`/${tenanturl}`}
								className="text-decoration-none text-black"
							>
								{language?.static_labels.home}
							</Link>
						</li>
						<li className="breadcrumb-item">
							<Link className="text-decoration-none text-black">
								{language?.static_labels.offers}
							</Link>
						</li>
						{offer ? (
							<li
								className="breadcrumb-item active"
								aria-current="page"
								style={{ color: "#1434CB" }}
							>
								{offer?.title}
							</li>
						) : (
							<li className="breadcrumb-item active w-25" aria-current="page">
								<div className="placeholder-glow ms-3 mt-1">
									<div className="placeholder"></div>
								</div>
							</li>
						)}
					</ol>
				</nav>
				{offer ? (
					<div>
						<div className="row mt-5">
							<div className="col-md-5">
								<div
									id="divOD"
									className="carousel slide"
									data-bs-ride="carousel"
								>
									{/* Carousel indicators */}
									<div className="carousel-indicators od-carousel-indicators">
										{offer?.images?.map((image, index) => (
											<button
												type="button"
												data-bs-target="#divOD"
												data-bs-slide-to={index}
												className={`${index === 0 ? "active" : ""} bg-dark`}
												key={index}
											></button>
										))}
									</div>

									{/* Carousel inner */}
									<div className="carousel-inner">
										{offer?.images?.map((image, index) => (
											<div
												className={`carousel-item od-carousel-item ${index === 0 ? "active" : ""
													}`}
												key={index}
											>
												<img
													src={DOMPurify.sanitize(image)}
													className="d-block w-100 rounded-4"
													alt="..."
												/>
											</div>
										))}
									</div>

									{/* Carousel controls */}
									{offer?.images?.length > 1 ? (
										<button
											className="carousel-control-prev carousel-control-od"
											type="button"
											data-bs-target="#divOD"
											data-bs-slide="prev"
										>
											<i
												className="align-content-center bg-light bi bi-chevron-left border border-1 rounded-circle text-dark"
												style={{ width: "25px", height: "25px" }}
											></i>
											<span className="visually-hidden">Previous</span>
										</button>
									) : (
										""
									)}
									{offer?.images?.length > 1 ? (
										<button
											className="carousel-control-next carousel-control-od"
											type="button"
											data-bs-target="#divOD"
											data-bs-slide="next"
										>
											<i
												className="align-content-center bg-light bi bi-chevron-right border border-1 rounded-circle text-dark"
												style={{ width: "25px", height: "25px" }}
											></i>
											<span className="visually-hidden">Next</span>
										</button>
									) : (
										""
									)}
								</div>
							</div>
							<div className="col-md-7 mt-5 mt-md-0">
								<div className="od-card">
									<div className="card-body od-card-body">

										{
											(offer?.targetLevel === "MERCHANTS") ?
												(offer.targetMerchants.length > 1) ?
													<div className="row" style={{ position: "relative" }}>
														{
															offer?.offerLogo === "" ?
																<div className="ms-2 od-merchant-logo d-inline w-auto agnostinc-offer-detail ow-primary-blue"
																	style={{ backgroundImage: `url(${process.env.REACT_APP_CLOUDFRONT}icons/agnostic_merchant_offer.png)` }}>
																</div>
																:
																<div className="w-auto" style={{ width: "fit-content" }}>
																	<img
																		src={DOMPurify.sanitize(offer?.offerLogo)}
																		className="od-merchant-logo"
																		alt="Merchant Logo"
																	/>
																</div>
														}
														<button className={(offer?.offerLogo === "") ? "agnostic-offer-detail-badge-common" : "agnostic-offer-detail-badge-logo"}>
															{offer.targetMerchants.length}
														</button>

														<div className="col section_title">
															<h1 className="sub_title" style={{ marginTop: "30px" }}>
																{offer.merchantDisplayName && offer.merchantDisplayName !== null ? offer.merchantDisplayName : language?.static_labels.agnostic_merchant_offer}
															</h1>
															<OverlayTrigger
																delay={{ hide: 450, show: 300 }}
																overlay={
																	<Popover id={`popover-positioned`}>
																		<Popover.Body>
																			{
																				offer.targetMerchants.map((merch) => {
																					return <div className="row pt-2 pb-2 ms-0 me-0 agnostic-bottom-border">
																						<div className="agnostic-popoverLogo d-inline w-auto">
																							<img
																								src={merch.image}
																								alt={merch.name}
																								className="rounded-circle"
																							/>
																						</div>
																						<div className="col agnostic-popoverName text-truncate text-black">
																							{merch.name}
																						</div>
																					</div>
																				})
																			}
																		</Popover.Body>
																	</Popover>
																}
																placement="bottom"
																trigger="click"
															>
																<span class="badge ow-primary-light-blue  fw-normal fs-11" >{language?.static_labels.agnostic_see_all_merchants} <i class=" ms-1 mt-2 bi bi-chevron-down"></i></span>
															</OverlayTrigger>
														</div>
													</div>
													: <div className="row">
														<div className="w-auto" style={{ width: "fit-content" }}>
															<img
																src={DOMPurify.sanitize(offer?.targetMerchants[0]?.image)}
																className="od-merchant-logo"
																alt="Merchant Logo"
															/>
														</div>
														<div className="col section_title">
															<h1 className="sub_title" style={{ lineHeight: "120px" }}>
																{offer.merchantDisplayName && offer.merchantDisplayName !== null ? offer.merchantDisplayName : offer?.targetMerchants[0]?.name}
															</h1>
														</div>
													</div>
												: (offer?.targetLevel === "CATEGORIES") ?
													<div className="row" style={{ position: "relative" }}>
														{
															offer?.offerLogo === "" ?
																<div className="ms-2 od-merchant-logo d-inline w-auto agnostinc-offer-detail ow-primary-blue"
																	style={{ backgroundImage: `url(${process.env.REACT_APP_CLOUDFRONT}icons/agnostic_category_offer.png)` }}>
																</div>
																:
																<div className="w-auto" style={{ width: "fit-content" }}>
																	<img
																		src={DOMPurify.sanitize(offer?.offerLogo)}
																		className="od-merchant-logo"
																		alt="Merchant Logo"
																	/>
																</div>
														}
														<button className={(offer?.offerLogo === "") ? "agnostic-offer-detail-badge-common" : "agnostic-offer-detail-badge-logo"}>
															{offer.targetCategories.length}
														</button>

														<div className="col section_title">
															<h1 className="sub_title" style={{ marginTop: "30px" }}>
																{offer.merchantDisplayName && offer.merchantDisplayName !== null ? offer.merchantDisplayName : language?.static_labels.agnostic_category_offer}
															</h1>
															<OverlayTrigger
																delay={{ hide: 450, show: 300 }}
																overlay={
																	<Popover id={`popover-positioned`}>
																		<Popover.Body>
																			{
																				offer.targetCategories.map((merch) => {

																					return language?.categories.map((category) => {
																						if (category.category === merch.name) {
																							return <div className="row pt-2 pb-2 ms-0 me-0 agnostic-bottom-border">
																								<div className="agnostic-popoverLogo-category d-inline w-auto" >
																									<img
																										src={`${process.env.REACT_APP_CLOUDFRONT
																											}categories/${DOMPurify.sanitize(
																												params.tenanturlpathname
																											)}/${category.category.split("/").join("")}.svg`}
																										alt={merch.name}
																										className="rounded-circle"
																									/>
																								</div>
																								<div className="col agnostic-popoverName text-truncate text-black">
																									{category.catalias}
																								</div>
																							</div>
																						}
																					})
																				})
																			}
																		</Popover.Body>
																	</Popover>
																}
																placement="bottom"
																trigger="click"
															>
																<span class="badge ow-primary-light-blue  fw-normal fs-11" >{language?.static_labels.agnostic_see_all_categories} <i class=" ms-1 mt-2 bi bi-chevron-down"></i></span>

															</OverlayTrigger>
														</div>
													</div> :
													(offer?.targetLevel === "CARDHOLDER") ?
														<div className="row">
															{
																offer?.offerLogo === "" ?
																	<div className="ms-2 od-merchant-logo d-inline w-auto agnostinc-offer-detail ow-primary-blue"
																		style={{ backgroundImage: `url(${process.env.REACT_APP_CLOUDFRONT}icons/agnostic_cardholder_offer.png)` }}>
																	</div>
																	:
																	<div className="w-auto" style={{ width: "fit-content" }}>
																		<img
																			src={DOMPurify.sanitize(offer?.offerLogo)}
																			className="od-merchant-logo"
																			alt="Merchant Logo"
																		/>
																	</div>
															}
															<div className="col section_title">
																<h1 className="sub_title" style={{ lineHeight: "120px" }}>
																	{offer.merchantDisplayName && offer.merchantDisplayName !== null ? offer.merchantDisplayName : language?.static_labels.agnostic_cardholder_offer}
																</h1>
															</div>

														</div> : ""
										}
										<h3 className="od-offer-title mt-3">{offer?.title}</h3>

										<div className="mb-3">
											{offer?.activationRequired ? (
												<SingleOfferActivation
													offer={offer}
													isAttrLoaded={isAttrLoaded}
													client={client}
													activated={activated}
													singleOfferActivated={singleOfferActivated}
													remainingTime={remainingTime}
													isUnderGap={isUnderGap}
													activateOffer={activateOffer}
													tenanturl={tenanturl}
													language={language}
													tenant={tenant}
													isUnlimitedReactivation={isUnlimitedReactivation}
													unlimitedOfferActivated={unlimitedOfferActivated}
													isFinalActivation={isFinalActivation}
												/>
											) : (
												// <div className="od-activate me-2 ">
												//   {isAttrLoaded ? (
												//     client ? (
												//       activated ? (
												//         offer.activationExpiry &&
												//         offer.remainingActivations ? (
												//           <div>
												//             <div
												//               className="border-primary btn mt-2 rounded-5 text-primary text-start"
												//               disabled
												//             >
												//               <i class="bi bi-clock-fill float-start mt-1 me-2 fs-1"></i>{" "}
												//               {
												//                 language?.static_labels
												//                   .activation_expire_in
												//               }{" "}
												//               <br />
												//               {remainingTime}
												//             </div>

												//             <div
												//               className="btn btn-success ms-2 mt-2 pb-3 pt-3 rounded-5"
												//               disabled
												//             >
												//               {language?.static_labels.activated}{" "}
												//             </div>
												//           </div>
												//         ) : (
												//           <div
												//             className="btn btn-success ms-2 mt-2 pb-3 pt-3 rounded-5"
												//             disabled
												//           >
												//             {language?.static_labels.activated}{" "}
												//           </div>
												//         )
												//       ) : !offer.remainingActivations ||
												//         offer.remainingActivations > 0 ? (
												//         <div>
												//           {isUnderGap ? (
												//             <div
												//               className="border-primary btn mt-2 rounded-5 text-primary text-start me-3"
												//               style={{ minWidth: "225px" }}
												//               disabled
												//             >
												//               <i class="bi bi-clock-fill float-start mt-1 me-2 fs-1"></i>{" "}
												//               {language?.static_labels.reactivate_in}{" "}
												//               <br />
												//               {remainingTime}
												//             </div>
												//           ) : (
												//             ""
												//           )}

												//           <button
												//             type="submit"
												//             variant="primary"
												//             disabled={isUnderGap}
												//             className="btn btn-secondary rounded-5 mt-2"
												//             onClick={activateOffer}
												//           >
												//             <i className="bi bi-wallet2 me-3"></i>
												//             {language?.static_labels.activate}
												//           </button>
												//         </div>
												//       ) : (
												//         ""
												//       )
												//     ) : (
												//       <Link
												//         to={`/${tenanturl}/signin`}
												//         className="text-decoration-none btn btn-secondary rounded-5 mt-2"
												//         title={
												//           language?.static_labels.signin_to_activate
												//         }
												//       >
												//         {language?.static_labels.signin_to_activate}
												//       </Link>
												//     )
												//   ) : (
												//     ""
												//   )}
												// </div>
												""
											)}
										</div>

										<p
											dangerouslySetInnerHTML={{
												__html: DOMPurify.sanitize(offer?.description),
											}}
											className="od-offer-desscription"
										></p>

										<div className="offerOptionslist">
											<ul>
												{offer?.minimumSpend ? (
													<li>
														{language?.static_labels.minimum_spend}{" "}
														{offer?.currency} {offer?.minimumSpend}
													</li>
												) : (
													""
												)}

												{(tenant?.tenantmasterconfig.common
													.start_date_display === "Y" ||
													(tenant?.tenantmasterconfig.common
														.end_date_display === "Y" &&
														offer.validTo)) && (
														<li>
															{language?.languageid === "529" ? (
																<>
																	{tenant?.tenantmasterconfig.common
																		.start_date_display === "Y" &&
																		`${FormatDateYYYYMDD(
																			checkStartDate(offer)
																		)} ${language?.static_labels.valid_from}`}
																	{tenant?.tenantmasterconfig.common
																		.start_date_display === "Y" &&
																		tenant?.tenantmasterconfig.common
																			.end_date_display === "Y" &&
																		offer.validTo &&
																		` ${FormatDateYYYYMDD(offer.validToUTC)} ${language?.static_labels.valid_to
																		}`}
																	{tenant?.tenantmasterconfig.common
																		.start_date_display === "N" &&
																		tenant?.tenantmasterconfig.common
																			.end_date_display === "Y" &&
																		offer.validTo &&
																		`${FormatDateYYYYMDD(offer.validToUTC)} ${language?.static_labels.valid_until
																		}`}
																</>
															) : (
																<>
																	{tenant?.tenantmasterconfig.common
																		.start_date_display === "Y" &&
																		`${language?.static_labels.valid_from
																		} ${FormatDateShortMonth(
																			checkStartDate(offer)
																		)}`}
																	{tenant?.tenantmasterconfig.common
																		.start_date_display === "Y" &&
																		tenant?.tenantmasterconfig.common
																			.end_date_display === "Y" &&
																		offer.validTo &&
																		` ${language?.static_labels.valid_to
																		} ${FormatDateShortMonth(offer.validToUTC)}`}
																	{tenant?.tenantmasterconfig.common
																		.start_date_display === "N" &&
																		tenant?.tenantmasterconfig.common
																			.end_date_display === "Y" &&
																		offer.validTo &&
																		`${language?.static_labels.valid_until
																		} ${FormatDateShortMonth(offer.validToUTC)}`}
																</>
															)}
														</li>
													)}
												{tenant?.tenantmasterconfig.common.budget === "Y" && (
													<li>{language?.static_labels.budget}: {offer?.budget}</li>
												)}
												{tenant?.tenantmasterconfig.common
													.redemptions_remaining === "Y" && (
														<li>
															{language?.static_labels.redemption_remaining}: {offer?.redemptionsRemaining}
														</li>
													)}
											</ul>
										</div>

										<div>
											{offer?.tags?.map((tag) => (
												<div className="od-tags-styles">{tag}</div>
											))}
										</div>

										{offer.activationRequired ? (
											<label className="text-muted mb-3 mt-2">
												{language?.static_labels.offer_redeem_message}
											</label>
										) : (
											""
										)}

										<div className="">
											{offer?.targetMerchants[0]?.website ? (
												<a
													className="btn btn-primary me-2 rounded-5 od-shop-now"
													href={DOMPurify.sanitize(offer.targetMerchants[0]?.website)}
													target="_blank"
												>
													{language?.static_labels.shopnow}
												</a>
											) : (
												""
											)}
											{locations?.length > 0 ? (
												<button
													className="btn btn-dark me-2 rounded-5 od-view-loc"
													data-bs-toggle="modal"
													data-bs-target="#modalStoreLocation"
												>
													<i class="bi bi-geo-alt-fill"></i> &nbsp;
													{language?.static_labels.viewstorelocations}
												</button>
											) : (
												""
											)}
										</div>
										<div className="onlineStore mb-3 ms-0">
											{offer.salesChannel === "ALL"
												? language?.static_labels.onlineandinstore
												: offer.salesChannel === "E-COMMERCE"
													? language?.static_labels.online
													: language?.static_labels.instore}
										</div>
										<div className="mt-4">
											<div class="dropdown">
												<button
													class="btn btn-outline-secondary pt-0 pb-0 dropdown-toggle rounded-pill"
													type="button"
													data-bs-toggle="dropdown"
													aria-expanded="false"
												>
													<i class="bi bi-share"></i>{" "}
													{language?.static_labels.share}{" "}
													<i class="bi bi-chevron-down"></i>
												</button>
												<ul class="dropdown-menu">
													<li>
														<div class="dropdown-item">
															<FacebookShareButton url={window.location.href}>
																<FacebookIcon size={28} round={true} />{" "}
																{language?.static_labels.facebook}
															</FacebookShareButton>
														</div>
													</li>
													<li>
														<div class="dropdown-item">
															<TwitterShareButton url={window.location.href}>
																<XIcon size={28} round={true} />{" "}
																{language?.static_labels.xtwitter}
															</TwitterShareButton>
														</div>
													</li>

													<li>
														<div class="dropdown-item">
															<LinkedinShareButton url={window.location.href}>
																<LinkedinIcon size={28} round={true} />{" "}
																{language?.static_labels.linkedin}
															</LinkedinShareButton>
														</div>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div>
							<div className="mt-5 od-tc">
								<div className="row mt-5">
									<label
										className="fw-bold mt-3 mb-2"
										style={{ fontSize: "16px" }}
									>
										{language?.static_labels.termsandconditions}:
									</label>
								</div>
								<div className="row mt-3">
									<label
										dangerouslySetInnerHTML={{
											__html: DOMPurify.sanitize(offer?.termsAndConditions),
										}}
										style={{ fontSize: "11px" }}
									></label>
									<a href={DOMPurify.sanitize(offer?.tncURL)} target="_blank">
										{DOMPurify.sanitize(offer?.tncText)}
									</a>
								</div>
							</div>
						</div>
					</div>
				) : (
					<Skeleton type="offerdetail" />
				)}
			</div >
			<div className="container mt-5 mb-5">
				<div className="row section_title mt-5">
					<h5 className="sub_title mt-5" style={{ fontSize: "16px" }}>
						{language?.static_labels.recommended_offers}
					</h5>
				</div>
				<div className="mt-3">
					{offer ? (
						<RecommendedOffers
							category={offer?.targetMerchants[0]?.category.name}
							offerId={offer?.id}
						/>
					) : (
						<Skeleton type="offer" count="4" />
					)}
					{/* {offers?.map((offer, index) => (
index < 4 && <OfferItemSection key={offer.id} offer={offers} />
))} */}
				</div>
			</div>

			<div
				class="modal fade"
				id="modalStoreLocation"
				tabindex="-1"
				aria-labelledby="modalStoreLocationLable"
				aria-hidden="true"
			>
				<div class="modal-dialog modal-fullscreen">
					<div class="modal-content">
						<div class="modal-header">
							<h1 class="modal-title fs-5" id="modalStoreLocationLable">
								{language?.static_labels.viewstorelocations}
							</h1>
							<button
								type="button"
								class="btn-close"
								data-bs-dismiss="modal"
								aria-label="Close"
							></button>
						</div>
						<div class="modal-body">
							{/* <div className="row h-100"> */}
								{/* <div className="col-md-4 border-end h-100 overflow-hidden">
									<div>
										<input type="text" class="form-control mb-2" id="txtFilterLocations" placeholder="Search..."
											onChange={filterLocations} />
									</div>
									<div className="overflow-y-auto h-100">
										{locations?.length > 0
											? locationsFiltered?.map((loc, index) => {
												const selectedloc = index === 0 ? "ow-primary-blue" : "";
												return (
													<div
														className={`position-relative p-3 pt-3 pb-3 border-bottom locationdiv ${selectedloc}`}
														key={index}
														location={JSON.stringify({
															lat: loc.latitude,
															lng: loc.longitude,
														})}
														nameandaddress={JSON.stringify({
															name: loc.name,
															address: loc.address,
														})}
														onClick={(e) => selectStore(e)}
													>
														<i class="bi bi-geo-alt-fill mt-1 pt-3 position-absolute top-0"></i>
														<div className="ms-4 me-4">
															<p className="fw-bold">{loc.name}</p>
															<p>{loc.address}</p>
														</div>
														<i
															class="bi bi-arrow-right position-absolute top-50"
															style={{ right: "10px" }}
														></i>
													</div>
												);
											})
											: ""
										}
									</div>
								</div> */}
								{
									language && locations ? <GMap locations={locations} /> : ""
								}
								{/* <div className="col-md-8 mt-5 mt-md-auto">
									{locations?.length > 0 && isLoaded ? (
										<GoogleMap
											mapContainerStyle={{
												width: "100%",
												height: "100%",
											}}
											center={mapCenter}
											zoom={15}
											// onLoad={onLoad}
											onUnmount={onUnmount}
										>
											{locationsFiltered?.map((loc) => {
												return (
													<Marker
														position={{ lat: loc.latitude, lng: loc.longitude }}
													>
														
													</Marker>
												);
											})}
											
											{mapCenter && (
												<InfoWindow position={mapCenter}>
													<div className="">
														<p className="fw-bold">{locInfo.name}</p>
														<p>{locInfo.address}</p>
													</div>
												</InfoWindow>
											)}
										</GoogleMap>
									) : (
										<></>
									)}
								</div> */}
							{/* </div> */}
						</div>
						<div class="modal-footer">
							<button
								type="button"
								class="btn btn-secondary"
								data-bs-dismiss="modal"
							>
								Close
							</button>
							{/* <button type="button" class="btn btn-primary">Save changes</button> */}
						</div>
					</div>
				</div>
			</div>

			<Modal
				show={showMessageModal}
				onHide={closeMessageModal}
				backdrop="static"
				keyboard={false}
			>
				<Modal.Header closeButton>
					<Modal.Title>
						{language?.static_labels.no_card_modal_title}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>{language?.static_labels.no_card_modal_message}</Modal.Body>
				<Modal.Footer>
					{/* <Button variant="secondary" onClick={closeMessageModal}>
{language?.static_labels?.later}
</Button> */}
					<Link
						to={`/${tenanturl}/user/cashback`}
						className="btn btn-secondary"
					>
						{language?.static_labels.ok}
					</Link>
				</Modal.Footer>
			</Modal>
			{
				loader ? (
					<div className="ow-full-overlay">
						<div className="position-absolute ow-content-center text-center">
							<Spinner animation="border" backdrop="static" variant="light" />
							<h3 className="text-light">{message}</h3>
						</div>
					</div>
				) : (
					""
				)
			}
		</>
	);
}

// export function MyMapComponent({ locations }) {
// const refmap = useRef();
// const [currentLoc, setCurrentLoc] = useState();

// const getCurrentLocation = (position) => {
// setCurrentLoc({ lat: position.coords.latitude, lng: position.coords.longitude })
// }
// useEffect(() => {
// let a
// if (navigator.geolocation) {
// a = navigator.geolocation.getCurrentPosition(getCurrentLocation);
// } else {

// }

// const map = new window.google.maps.Map(refmap.current, {
// center: currentLoc,
// zoom: 10,
// });
// // locations.push(currentLoc)
// locations.map(
// position =>
// new window.google.maps.Marker({
// position,
// map,
// }),
// );
// }, []);

// return <div ref={refmap} id="map" style={{ width: "100%", height: "100%" }} />;
// }
